import { Component, ElementRef } from '@angular/core';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { OverlapService } from '../../service/overlapService/overlap.service';

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss']
})
export class PdfViewerComponent {
  pdfUrl: SafeResourceUrl | null = null;
  blobUrl: string | null = null;

  constructor(
    private sanitizer: DomSanitizer,
    private overlayService: OverlapService
  ) {}

  loadPdf(blob: Blob) {
    this.blobUrl = window.URL.createObjectURL(blob);
    this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.blobUrl);
  }

  close() {
    this.overlayService.closeOverlay();
  }

  ngOnDestroy() {
    if (this.blobUrl) {
      window.URL.revokeObjectURL(this.blobUrl);
    }
  }
}
